import React from 'react'

export default function NavDivider({margin="2rem -4rem"})
{
	return (
		<div style={{
            margin,
            borderBottom:'1px solid #dedede'
        }}/>
	)
}
